"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const WorldSmallIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m-.5-2.035A3.994 3.994 0 0 1 8 12c0-.31.04-.605.105-.895L10.5 13.5v.5c0 .55.45 1 1 1zm3.45-1.27A.99.99 0 0 0 14 14h-.5v-1.5c0-.275-.225-.5-.5-.5h-3v-1h1c.275 0 .5-.225.5-.5v-1h1c.55 0 1-.45 1-1v-.205A4 4 0 0 1 16 12c0 1.04-.4 1.985-1.05 2.695"/></svg>`
}, props));
WorldSmallIcon.displayName = 'WorldSmallIcon';
var _default = exports.default = WorldSmallIcon;